import {Injectable} from "@angular/core";
import {HttpService} from "../http/http.service";
import {Observable, Subject} from "rxjs";
import {TourTimetable, TourApplication} from "./tour-application";

@Injectable()
export class TourApplicationService {
  private url = '/api/applications/tour';
  public applications: TourApplication[];

  constructor(private httpService: HttpService) {
  }

  getTimetable(location: string): Observable<TourTimetable[]> {
    return this.httpService.get(`${this.url}/timetable?location=${location}`)
      .map(res => res.json() as TourTimetable[]);
  }

  apply(application: TourApplication) {
    return this.httpService.post(`${this.url}/apply`, application)
      .map(res => res.json() as TourApplication);
  }

  lookup(name: string, phone: string): Observable<TourApplication[]> {
    return this.httpService.get(`${this.url}/lookup?name=${name}&phone=${phone}`)
      .map(res => res.json() as TourApplication[]);
  }

  cancle(id: number, name: string, phone: string) {
    return this.httpService.get(`${this.url}/cancel?id=${id}&name=${name}&phone=${phone}`)
      .map(res => res.json());
  }
}


// WEBPACK FOOTER //
// ./src/app/service/tour-application/tour-application.service.ts